<section class="bg-white rounded-b-xl shadow p-4 md:p-6">
  <h2 class="font-semibold uppercase text-xl sm:text-2xl md:text-3xl text-gray-900 mb-3">Lista de inscritos</h2>
  <p class="border-4 w-full border-black mb-4"></p>

  <div class="border border-gray-200 rounded-lg overflow-hidden">
    <div class="divide-y divide-gray-200">
      <a
        *ngFor="let a of attendees; trackBy: track"
        [routerLink]="['/members', a.id]"
        class="flex items-center justify-between p-3 text-gray-900 hover:bg-gray-50 focus:outline-none focus-visible:bg-gray-50 transition-colors"
      >
        <span class="flex items-center gap-3 min-w-0">
          <img
            [src]="a.avatarUrl || '/assets/avatars/_placeholder.png'"
            [alt]="a.name"
            class="w-14 h-14 shrink-0 rounded-full object-cover bg-gray-100"
          />
          <span class="truncate">{{ a.name }}</span>
        </span>
        <span *ngIf="a.isVip" class="text-xs shrink-0 rounded-full bg-amber-100 text-amber-700 px-2 py-1">VIP</span>
      </a>
    </div>
  </div>
</section>
